import { render, staticRenderFns } from "./RouteTextResource.vue?vue&type=template&id=0d548402&scoped=true&lang=pug"
import script from "./RouteTextResource.vue?vue&type=script&lang=js"
export * from "./RouteTextResource.vue?vue&type=script&lang=js"
import style0 from "./RouteTextResource.vue?vue&type=style&index=0&id=0d548402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d548402",
  null
  
)

export default component.exports